/**
 * Rotating text ticker (product page).
 *
 * Cycles through the block's text lines automatically on a timer, each
 * one blurring out in place while the next blurs in (no manual
 * controls — autoplay only). Pauses while the browser tab isn't
 * visible, and resumes on return.
 *
 * Also keeps the viewport's height matched to whichever line currently
 * needs the most room at the current viewport width — merchant-entered
 * text can wrap to two or more lines on narrower screens, and since
 * every line is absolutely positioned (see rotating-text.liquid), none
 * of them contribute to the container's natural height on their own,
 * so without this a wrapped line would get clipped by the container's
 * fixed height instead of showing in full.
 */
(function () {
  function setupTicker(root) {
    var viewport = root.querySelector('.rotating-text__viewport');
    var items = Array.prototype.slice.call(
      root.querySelectorAll('.rotating-text__item')
    );
    if (!viewport || items.length === 0) return;

    function updateHeight() {
      var maxHeight = 0;
      items.forEach(function (item) {
        // Briefly lay the line out normally (in the viewport's actual
        // width) to measure how tall it really is once wrapped, then
        // put it straight back into the absolute stack.
        var prevPosition = item.style.position;
        var prevVisibility = item.style.visibility;
        item.style.position = 'static';
        item.style.visibility = 'hidden';
        var height = item.getBoundingClientRect().height;
        item.style.position = prevPosition;
        item.style.visibility = prevVisibility;
        if (height > maxHeight) maxHeight = height;
      });
      if (maxHeight > 0) {
        viewport.style.minHeight = maxHeight + 'px';
      }
    }

    updateHeight();
    window.addEventListener('resize', updateHeight);

    if (items.length < 2) return; // nothing to rotate — just static text

    var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 4000;
    var timer = null;

    var index = items.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    if (index === -1) index = 0;

    function next() {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(next, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    startAutoplay();
  }

  function init() {
    document.querySelectorAll('.rotating-text').forEach(setupTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();